import React from 'react'
import { App, Upload } from 'antd'
import { useSelector } from 'react-redux'
import { UploadProps } from 'antd/lib'
import { useTranslation } from 'react-i18next'
import { AxiosError } from 'axios'
import { useQueryClient } from '@tanstack/react-query'
import { createLoanImport } from '../service/loanService'
import { contextCompanyIdSelector } from '../../../redux/context/company/selectors'
import { filtersSelector } from '../../../redux/context/filters/selectors'
import loanQueryKeys from '../queries/loanQueryKeys'

const LoanImport = () => {
  const { t } = useTranslation()
  const { notification } = App.useApp()
  const queryClient = useQueryClient()
  const companyId = useSelector(contextCompanyIdSelector)!
  const { budgetingScenario: { id: budgetingScenarioId } = {} } = useSelector(filtersSelector)

  const handleSubmit: UploadProps['customRequest'] = async ({ file }) => {
    try {
      const formData = new FormData()
      formData.append('file', file)

      await createLoanImport({ data: formData, companyId, budgetingScenarioId })
      queryClient.invalidateQueries({
        queryKey: loanQueryKeys.summaries()
      })
    } catch (error) {
      if (error instanceof AxiosError) {
        notification.error({
          message: t('message:IMPORT_ERROR'),
          description: t(`error:${error?.response?.data.message}`, t('description:CONTACT_SUPPORT'))
        })
      }
    }
  }

  const props: UploadProps = {
    name: 'file',
    multiple: false,
    accept: '.xlsx',
    showUploadList: false,
    customRequest: handleSubmit
  }

  return <Upload {...props}>{t('loans:import')}</Upload>
}

export default LoanImport
